import { FC } from "react";
import { IconProps } from ".";

export const SearchIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={15 * size}
    height={14 * size}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.93776 1.91544C7.76334 -0.258976 4.237 -0.258977 2.06259 1.91544C-0.111831 4.08986 -0.111831 7.6162 2.06259 9.79061C3.98884 11.7169 6.9763 11.9343 9.14363 10.4477L11.8546 13.48C12.3154 13.9976 13.1167 14.0189 13.6059 13.5297L13.6768 13.4588C14.1661 12.9695 14.1448 12.1683 13.6272 11.7074L10.5948 8.99648C12.0838 6.82679 11.864 3.84169 9.93776 1.91544ZM8.58584 8.43869C7.15829 9.86625 4.84206 9.86625 3.41451 8.43869C1.98696 7.01114 1.98696 4.69491 3.41451 3.26736C4.84206 1.83981 7.15829 1.83981 8.58584 3.26736C10.0158 4.69728 10.0134 7.01114 8.58584 8.43869Z"
      fill={color}
    />
  </svg>
);

export const ArrowDownIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={16 * size}
    height={24 * size}
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 16L14.59 14.59L9 20.17V0H7V20.17L1.42 14.58L0 16L8 24L16 16Z"
      fill={color}
    />
  </svg>
);

export const ChevronRightIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={9 * size}
    height={14 * size}
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12.1967L5.28313 6.91358L0 1.63045L1.63045 0L8.54404 6.91358L1.63045 13.8272L0 12.1967Z"
      fill={color}
    />
  </svg>
);

export const RatingIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={16 * size}
    height={16 * size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.586 5.83401L10.6434 5.11578L8.433 0.637055C8.34447 0.457739 8.17223 0.36792 8 0.36792L8.00064 13.2517L12.4208 15.5757C12.7752 15.7618 13.1889 15.4611 13.1213 15.0667L12.2772 10.1437L15.8535 6.65751C16.1404 6.37807 15.982 5.89163 15.586 5.83401Z"
      fill={color}
    />
    <path
      d="M11.2393 9.80665C11.2393 9.80665 12.0016 14.2503 12.0042 14.2651C12.0016 14.2648 8.06214 13.2671 8.00065 13.2517C8 13.2513 3.57923 15.5757 3.57923 15.5757C3.22478 15.7618 2.8111 15.4611 2.8787 15.0667L3.72281 10.1437L0.146464 6.65751C-0.140377 6.37807 0.0180135 5.89163 0.41399 5.83401L5.35662 5.11578L7.567 0.637055C7.65554 0.457739 7.82777 0.36792 8 0.36792L10.0021 5.99852L14.4789 6.64914L11.2393 9.80665Z"
      fill={color}
    />
  </svg>
);

export const ConsoleIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={20 * size}
    height={14 * size}
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2119 2.71879C15.5702 -1.62127 11.5908 1.39816 11.5908 1.39816C11.3327 1.59322 10.8568 1.75359 10.5335 1.75434L9.46759 1.75508C9.14423 1.75545 8.66835 1.59508 8.41064 1.40003C8.41064 1.40003 4.43085 -1.62015 1.78885 2.71991C-0.852409 7.05848 0.212 11.7834 0.212 11.7834C0.398477 12.9403 1.0131 13.7123 2.17299 13.6154C3.32952 13.5188 5.83987 10.4997 5.83987 10.4997C6.04723 10.251 6.48172 10.0477 6.80432 10.0477L13.1945 10.0466C13.5175 10.0466 13.9516 10.2498 14.1586 10.4986C14.1586 10.4986 16.6693 13.5177 17.8277 13.6143C18.9861 13.7112 19.6022 12.9385 19.7876 11.7823C19.7872 11.7823 20.8535 7.05811 18.2119 2.71879ZM7.59872 6.25141H6.22849V7.57204C6.22849 7.57204 5.93833 7.79357 5.48929 7.78798C5.041 7.78126 4.83811 7.5463 4.83811 7.5463V6.25178H3.54397C3.54397 6.25178 3.38248 6.08619 3.33921 5.65021C3.2967 5.21422 3.51786 4.86178 3.51786 4.86178H4.88846V3.49155C4.88846 3.49155 5.17042 3.34051 5.57582 3.35207C5.98159 3.36475 6.27883 3.51729 6.27883 3.51729L6.27324 4.86141H7.56739C7.56739 4.86141 7.7934 5.15157 7.81204 5.50215C7.83069 5.85309 7.59872 6.25141 7.59872 6.25141ZM13.8837 7.75665C13.2836 7.75665 12.7999 7.27144 12.7999 6.6721C12.7999 6.07164 13.2836 5.58755 13.8837 5.58755C14.4812 5.58755 14.9686 6.07164 14.9686 6.6721C14.9686 7.27181 14.4812 7.75665 13.8837 7.75665ZM13.8837 4.77265C13.2836 4.77265 12.7999 4.28781 12.7999 3.68847C12.7999 3.08802 13.2836 2.60392 13.8837 2.60392C14.4812 2.60392 14.9686 3.08802 14.9686 3.68847C14.9686 4.28818 14.4812 4.77265 13.8837 4.77265ZM16.5847 6.37448C15.9846 6.37448 15.5009 5.88964 15.5009 5.28993C15.5009 4.68985 15.9846 4.20539 16.5847 4.20539C17.1821 4.20539 17.6696 4.68985 17.6696 5.28993C17.6696 5.88964 17.1821 6.37448 16.5847 6.37448Z"
      fill={color}
    />
  </svg>
);

export const PlayIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={30 * size}
    height={38 * size}
    viewBox="0 0 30 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.34375 35.875V2.12497C0.34375 1.34703 0.771953 0.632232 1.45778 0.2652C2.14361 -0.101831 2.97597 -0.0616128 3.62313 0.369825L28.9356 17.2448C29.5225 17.636 29.875 18.2946 29.875 19C29.875 19.7053 29.5226 20.3639 28.9356 20.7551L3.62313 37.6301C2.23727 38.5542 0.34375 37.5727 0.34375 35.875Z"
      fill={color}
    />
    <defs>
      <linearGradient
        id="paint0_linear_50_426"
        x1="15.1094"
        y1="37.9853"
        x2="15.1094"
        y2="0.0155911"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={color} />
        <stop offset="1" stop-color={color} />
      </linearGradient>
    </defs>
  </svg>
);
